<template>
  <div class="account account--center">
    <div class="wrapper">
      <div class="account__body">
        <div v-if="showCart" class="cart">

          <button class="btn btn-back hidden-xs" @click.prevent="goBack()">
            <span>{{ trans.text.cart.back }}</span>
          </button>

          <div class="cart-heading">
            <h2>{{ trans.text.cart.total }} <span>{{ sum }}</span></h2>
            <p class="w-100">{{ trans.text.cart.finalAmount }}</p>
          </div>
          <div class="cart-list">

            <cart-item-component
              v-for="(item,index) in cartItems"
              :key="index"
              :item="item"
              :lang="lang"
              :trans="trans"/>
          </div>

          <div class="cart-foot">
            <div class="cart-foot__subtotal">
              <span>{{ trans.text.cart.subtotal }}</span>
              <span class="cart-foot__subtotal-sum">{{ sum }}</span>
            </div>

            <!--                        <div class="cart-foot__shipping">-->
            <!--                            <span>Shipping in 30-90 business days.</span>-->
            <!--                            <span>Free</span>-->
            <!--                        </div>-->
            <div class="cart-foot__shipping">
              <span>{{ trans.text.cart.delivery }}</span>
              <span>{{ trans.text.cart.estimated }}<sup>*</sup></span>
            </div>
            <div class="cart-foot__period"><sup>*</sup><span class="text" v-html="trans.text.cart.deliveryInfo"></span>
            </div>

            <div class="cart-foot__total">
              <span>{{ trans.text.cart.totalLabel }}</span>
              <span class="cart-foot__total-sum">{{ sum }}</span>
            </div>

            <div class="cart-controls">
              <button class="btn btn-green btn-block" @click.prevent="checkout">
                {{ trans.text.cart.toCheckout }}
              </button>
            </div>
          </div>
        </div>

        <div v-if="!showCart" class="cart">
          <div class="cart-heading">
            <div v-if="getCartLoadingStatus" class="cart-empty">
              <h1>{{ trans.text.cart.loading }}</h1>
            </div>
            <div v-else class="cart-empty">
              <h2>{{ trans.text.cart.emptyBag }}</h2>
              <p></p>
              <a :class="'btn btn-green'" :href="'/'+lang+'/home'" style="width: 100%;max-width: 400px;">
                {{ trans.text.cart.toMain }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modalPrimary modal-sm custom-primary-modal" :class="{active: emailNotActivated}">
      <div class="modalBox text-center">
        <p class="text-lg">
          <span>
            Dear Customer, Please activate your email before start checkout.
          </span>
        </p>

        <div class="btn-modal-group">
          <button type="button" class="btn btn-green btn-sm w-100" @click.prevent="hideActivateEmailInfoModal">
            Ok
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import CartItemComponent from "./CartItemComponent";

export default {
  props: ['lang', 'trans'],
  name: "CartComponent",
  components: {CartItemComponent},
  data() {
    return {
      emailNotActivated: false,
    }
  },
  mounted() {
    this.loadCartItems();
  },
  computed: {
    ...mapGetters(['cartItems', 'storage', 'isAuth', 'getCartLoadingStatus', "getAuthUser",]),
    showCart() {
      return this.cartItems.length > 0;
    },
    total() {
      return this.cartItems.reduce((total, item) => item.quantity + total, 0);
    },
    sum() {
      let sum = 0;

      for (let item of this.cartItems) {
        if (item.is_pre_order) {
          sum += item.pre_order_price * item.quantity;
        } else {
          sum += (item.product.price + this.counting(item.product.rel_parts)) * item.quantity
        }
      }

      return this.$crConverter(sum, 'EUR');
    },
    language() {
      return this.lang;
    }
  },
  methods: {
    ...mapActions(['GetCartItems', 'Checkout']),
    hideActivateEmailInfoModal() {
      this.emailNotActivated = false

      let a = document.createElement('a')
      a.href = "/en/profile"
      a.target = "_blank"

      a.click()

      setTimeout(() => {
        a.remove()
      }, 20)
    },
    counting(parts) {
      let price = 0;
      for (let part of parts) {
        if (part.category.as_option === 1) {
          price += parseInt(part.price_out);
        }
      }
      return price;
    },
    loadCartItems() {
      this.GetCartItems({
        path: this.$path
      })
    },
    checkout() {
      let eventData = {
        currency: 'EUR',
        items: []
      };
      for (let item of this.cartItems) {
        eventData.items.push({
          'name': item.product.model.model,
          'price': item.is_pre_order ? 2000 : item.product.price,
          'quantity': item.quantity,
          'variant': this.getFramePart(item.product)
        })
      }
      this.$gtag.event('begin_checkout', eventData)
      setTimeout(() => {
        if (window.fbq) {
          window.fbq('track', 'InitiateCheckout', {
            currency: 'EUR',
            num_items: eventData.items.length,
            content_category: eventData.items[0] ? eventData.items[0].name : 'Product',
            value: 100,
            contents: eventData.items.map(item => {
              return {
                id: item.variant,
                quantity: item.quantity,
              }
            })
          })
        }
      })

      if (!this.isAuth) {
        localStorage.setItem('isRunCheckout', "true");
      }

      if (this.isAuth) {
        if (this.getAuthUser.email_verified_at) {
          location.href = `/en/checkout?redirect=true`
        } else {
          this.emailNotActivated = true
        }
      } else {
        location.href = `/${this.lang}/login`
      }
    },
    checkActivated() {
      return new Promise((resolve) => {
        this.$store.dispatch('checkout/checkActivated').then(response => {
          resolve(response.data.data.status)
        }).catch(err => {
          console.log("Error checking user activating", err)
          resolve(false)
        })
      })
    },
    goBack() {
      if (document.referrer === "") {
        window.close()
      } else {
        history.back()
      }
    },
    getFramePart(product) {
      let framePart = product.rel_parts.find(item => {
        return item.category.en_title === 'Frame'
      })[0]

      if (framePart) {
        return framePart.block_name_en;
      }
    }
  }
}
</script>

<style scoped>
.cart-item__total {
  /*width: 13% !important; - на странице /cart на телефоне цена слетает*/

}

.quantity_error {
  font-size: 13px;
  color: red;
}
</style>
